import { render, staticRenderFns } from "./alert.component.vue?vue&type=template&id=2a0cbb56&scoped=true&"
import script from "./alert.component.vue?vue&type=script&lang=js&"
export * from "./alert.component.vue?vue&type=script&lang=js&"
import style0 from "./alert.component.vue?vue&type=style&index=0&id=2a0cbb56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0cbb56",
  null
  
)

export default component.exports